import { clsx } from 'clsx';
import { TabsContent } from 'src/components/ui/tabs';
import React from 'react';
import { PersonaForm } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/PersonaForm';
import { LoaderWrapper } from 'src/components/LoaderWrapper/LoaderWrapper';
import { PersonaTabSkeleton } from 'src/pages/ConfigurationPage/PersonaTab/PersonaTabSkeleton/PersonaTabSkeleton';

export const PersonaTab = ({
  isCustomActiveSettings = false,
  formFieldsObject = {},
  inputData = {},
  readonly,
  submit = () => {},
  isLoading = false,
}) => {
  const formFieldsLength = Object.keys(formFieldsObject).length;

  return (
    <TabsContent
      className={clsx('py-2 mt-0 h-full rounded-sm-5 overflow-auto pr-2')}
      value={'persona'}
    >
      <LoaderWrapper isLoading={isLoading} loader={<PersonaTabSkeleton />}>
        {Boolean(formFieldsLength) && !isCustomActiveSettings ? (
          <PersonaForm
            formFieldsObject={formFieldsObject}
            inputData={inputData}
            readonly={readonly}
            compact={true}
          />
        ) : (
          <div
            className={
              'bg-[#F5FCFE] rounded-sm-5 border border-[#009CB240] flex items-center justify-center p-7.5'
            }
          >
            <p className={'text-center text-base font-medium text-[#009CB2]'}>
              Custom configuration by CoSupport AI.
              <br /> To request edits, reach out to your Account Manager.
            </p>
          </div>
        )}
      </LoaderWrapper>
    </TabsContent>
  );
};
